import { render, staticRenderFns } from "./ledger-flows.vue?vue&type=template&id=40e08977&scoped=true"
import script from "./ledger-flows.vue?vue&type=script&lang=js"
export * from "./ledger-flows.vue?vue&type=script&lang=js"
import style0 from "./ledger-flows.vue?vue&type=style&index=0&id=40e08977&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e08977",
  null
  
)

export default component.exports